module.exports = __webpack_public_path__ + "static/media/chevron.230fe1da.svg";